var _style, _defs, _g, _defs2, _g2, _circle, _defs3, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84 83",
    style: {
      enableBackground: "new 0 0 84 83"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#FDD44C;}\r\n\t.st2{clip-path:url(#SVGID_4_);}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st4{clip-path:url(#SVGID_6_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    transform: "translate(0.254 0.198)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -0.3,
    y: -0.2,
    width: 84,
    height: 83
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    transform: "translate(0 0)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    className: "st1",
    d: "M0.4,41.3C0.4,9,9.5,0,41.7,0S83,9,83,41.3s-9,41.3-41.3,41.3S0.4,73.5,0.4,41.3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    transform: "translate(-963.221 -2206.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    transform: "translate(963.221 2206.384)"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 19.4,
    y: 17.5,
    width: 37.3,
    height: 43.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    transform: "translate(0 0)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "st3",
    d: "M29.9,39.3c-2.3,0-4.1,1.8-4.1,4.1v8.2c0,2.3,1.8,4.1,4.1,4.1h16.4c2.3,0,4.1-1.8,4.1-4.1v-8.2 c0-2.3-1.8-4.1-4.1-4.1c0,0,0,0,0,0H29.9z M28.6,43.4c0-0.8,0.6-1.4,1.4-1.4h1.4v2.7c0,0.8,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4V42 h2.7v2.7c0,0.8,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4V42h2.7v2.7c0,0.8,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4V42h1.4 c0.8,0,1.4,0.6,1.4,1.4v8.2c0,0.8-0.6,1.4-1.4,1.4H45v-2.7c0-0.8-0.6-1.4-1.4-1.4s-1.4,0.6-1.4,1.4V53h-2.7v-2.7 c0-0.8-0.6-1.4-1.4-1.4s-1.4,0.6-1.4,1.4V53H34v-2.7c0-0.8-0.6-1.4-1.4-1.4s-1.4,0.6-1.4,1.4V53h-1.4c-0.8,0-1.4-0.6-1.4-1.4 V43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    className: "st3",
    d: "M27.2,17.3c-3.8,0-6.9,3.1-6.9,6.9c0,0,0,0,0,0v30.1c0,3.8,3.1,6.9,6.9,6.9c0,0,0,0,0,0h21.9 c3.8,0,6.9-3.1,6.9-6.9V33.1c0-1.7-0.6-3.3-1.7-4.6l-7.9-8.9c-1.3-1.5-3.2-2.3-5.1-2.3H27.2z M23.1,24.2c0-2.3,1.8-4.1,4.1-4.1 l0,0h14c1.2,0,2.3,0.5,3.1,1.4l7.9,8.9c0.7,0.8,1,1.7,1,2.7v21.2c0,2.3-1.8,4.1-4.1,4.1H27.2c-2.3,0-4.1-1.8-4.1-4.1l0,0V24.2z"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    className: "st1",
    cx: 1015.7,
    cy: 2263.9,
    r: 11.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    transform: "translate(987 2237)"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 19.4,
    y: 17.5,
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_905-2",
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    d: "M29.4,17.5c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10S34.9,17.5,29.4,17.5 M34.6,25.1L28.7,31 c-0.2,0.2-0.5,0.3-0.7,0.3c-0.3,0-0.5-0.1-0.7-0.3l-3-3c-0.4-0.4-0.4-1.1,0-1.5c0.4-0.4,1.1-0.4,1.5,0c0,0,0,0,0,0l2.2,2.2 l5.1-5.1c0.4-0.4,1.1-0.4,1.5,0c0,0,0,0,0,0C35,24,35,24.7,34.6,25.1L34.6,25.1z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimCard);
export default __webpack_public_path__ + "static/media/sim-card.d306c7a89b553374898bd1bd2542e158.svg";
export { ForwardRef as ReactComponent };